import { copy, type StatId } from './copy';
import { groupMethods, markets, type Market, type MethodKind } from './payments';

/**
 * The page's data-backed numbers, derived once from the payment schedule and the coin list.
 * Every count a section states comes from here, so the copy can never drift from the data.
 * Imports `copy` at runtime; `copy.ts` must not import this module back.
 */

/** Markets in the schedule, USDT included. */
export const MARKET_COUNT = markets.length;

/** Distinct method names across every market; shared rails (ShopeePay, BigPay, Online Bank Transfer) count once. */
export const METHOD_COUNT = new Set(
  markets.flatMap((market) => market.methods.map((method) => method.name)),
).size;

/** Local coins on the coins stage. */
export const COIN_COUNT = copy.coins.items.length;

/** The three counts the hero proof strip and the coins stat strip show, by copy id. */
export const STATS: Record<StatId, number> = {
  markets: MARKET_COUNT,
  methods: METHOD_COUNT,
  coins: COIN_COUNT,
};

/** Methods one market takes, both directions alike. */
export const marketMethodCount = (market: Market): number => market.methods.length;

/** Method kinds one market has at least one of, in rendered order. */
export const marketKinds = (market: Market): MethodKind[] =>
  groupMethods(market).map((group) => group.kind);
